import _ from "lodash";
import initialState from "./initialState";
import types from "../actions/actionTypes";
import Tools from "../../helpers/tools";

export default function userReducer(state, action) {
    switch (action.type) {
        case types.USER.SET_LOGGED_IN:
            _.set(action, `data.details.profile`, formatUser(_.get(action, `data.details.profile`)));

            return {
                ...state,
                ...action.data,
                isSuperUser: Tools.includesOneOf(_.get(action, `data.details.profile.T-Organisation`), [`TME`, `TMME`])
            };
        default:
            return state || initialState.loadInitials().user;
    }
}

function formatUser(user) {
    if (!user) {
        return user;
    }

    user[`Roles`] = splitIfNotArray(user, `Roles`);
    user[`T-Organisation`] = splitIfNotArray(user, `T-Organisation`);
    user[`T-OrganisationType`] = splitIfNotArray(user, `T-OrganisationType`);
    user[`T-GeographicLocation`] = splitIfNotArray(user, `T-GeographicLocation`);

    return user;
}

function splitIfNotArray(baseObject, path, delimiter = `^`) {
    const targetValue = baseObject && baseObject[path];
    if (targetValue) {
        if (Array.isArray(targetValue)) {
            if (targetValue[0].indexOf(delimiter) >= 0) {
                return targetValue[0].split(delimiter);
            }
            return targetValue;
        }
        return targetValue.split(delimiter);
    }

    return [];
}
